const AED_NUMBER_FORMAT = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatAedCurrency(value: unknown): string {
  const normalized =
    typeof value === "string"
      ? value.replace(/aed/gi, "").replace(/,/g, "").trim()
      : value;
  const amount = Number(normalized);
  return `AED ${AED_NUMBER_FORMAT.format(Number.isFinite(amount) ? amount : 0)}`;
}
